import React from 'react'

import Fichas from './../../utils/import.fichas'

interface Properties {
    CurrentCar?: any
}

interface Info {
    Nombre?: keyof typeof Fichas
    Fichas?: any
    mapa?: any
}

const getNombre = (payload: any) => {
    const mapa: Info = {Fichas}

    return (
        <React.Fragment>
            <div className='responsive-pdf-container'>
                <embed src={mapa.Fichas[payload]} width="100%" height="100%" className="fichas-desktop" />
                <a href={mapa.Fichas[payload]} download className="fichas-responsive">Descargar Ficha Técnica {payload}</a>
            </div>
        </React.Fragment>
    
    )
}

const FichasComponent = (property: Properties) => {
    return (
        <div className = "right-container">
            {
                getNombre(property.CurrentCar)
            }
        </div>
    )
}

export default FichasComponent;
